export default __webpack_public_path__ + "static/media/mov.66743180.png";